// Package imports:
import React from 'react';
// Style imports:
// import './PriceChangeRange.scss';
// Type imports:
import { formatNumber } from '../../services/utils';

interface IOwnProps {
    lastPrice: number | null,
    priceChangePercent: number | null
};
type Props = IOwnProps;

const PriceChangeRange: React.FC<Props> = ({ lastPrice, priceChangePercent }) => {
    const displayPriceAndChange = () => {
        const className = (priceChangePercent === null) // if
            ? ''
            : (priceChangePercent < 0) // else if
            ? 'Negative'
            : (priceChangePercent > 0) // else if
            ? 'Positive'
            : 'Neutral'

        const pricePercentDisplay = (priceChangePercent === null) // if
            ? ''
            : (priceChangePercent > 0) // else if
            ? '+' + (Math.round(priceChangePercent * 10000) / 100).toString() + '%'
            : (Math.round(priceChangePercent * 10000) / 100).toString() + '%';

        return (
            <>
                <p className='LastPrice'>{formatNumber(lastPrice)}</p>
                <div className={`PriceChangeWrapper ${className}`}>
                    <p className='PriceChange'>{pricePercentDisplay}</p>
                </div>
            </>
        )
    }

    return (
        <div id='PriceChangeRange'>
            <h5>Last Price:</h5>
            {displayPriceAndChange()}
        </div>
    );
}

export default PriceChangeRange;
